import Forgot from './auth/Forgot/Forgot.vue'
import Login from './auth/Login/Login.vue'
import Resend from './auth/Resend/Resend.vue'
import Reset from './auth/Reset/Reset.vue'
import SignUp from './auth/SignUp/SignUp.vue'
import SignUpSocial from './auth/SignUpSocial/SignUpSocial.vue'
import CompositeModalNew from './CompositeModalNew/CompositeModal.vue'
// import JobPublishing from './JobPublishing/JobPublishing.vue'
import Confirm2FA from './Confirm2FA/Confirm2FA.vue'
import ScamAlert from './ScamAlert/ScamAlert.vue'
import SuccessModal from './SuccessModal/SuccessModal.vue'
import install from '@/utils/installComponents'

const components = {
  // JobPublishing,
  Confirm2FA,
  CompositeModalNew,
  Login,
  SignUp,
  SignUpSocial,
  Resend,
  Forgot,
  Reset,
  ScamAlert,
  SuccessModal,
}

export default {
  ...components,
  install: install(components),
}
